import { useEffect } from 'react';
import Header from 'src/components/demo-day/header/Header';
import cx from '../demo-day/index.module.scss';
import styles from './index.module.scss';
import { findingBrilliantIcon } from 'src/assets/images';
import Stepper from 'src/components/demo-day-register/Stepper/Stepper';
import { Loader, TStep } from 'src/components/common';
import Register from 'src/components/demo-day-register/register/Register';
import { clearDemoDay, getDemoDay } from 'src/store/venture/venture.slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useUrlParamValue } from 'src/hooks';
import { useNavigate } from 'react-router-dom';
const DemoDayRegister = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch();
    const { ventureLoading } = useAppSelector(
        (store) => store.venture
    );
    const { paramValue } = useUrlParamValue();
    const ventureVerseId = paramValue({ paramName: 'id' });
    const steps: TStep[] = [
        { label: 'Register' },
        { label: 'Pitch Deck' },
        { label: 'Book A Slot' }
    ];

    useEffect(() => {
        if (ventureVerseId !== 'undefined') {
            dispatch(getDemoDay({ ventureVerseId }))
        } else {
            navigate('/demo-day')
        }
        return () => {
            dispatch(clearDemoDay())
        }
    }, [ventureVerseId]);
    return (
        <div className={cx.demoDay}>
            <Header />
            <div className={cx.demoDayContent}>
                <section className={styles.content}>
                    {!ventureLoading && <div className={styles.container}>
                        <div className={styles.left}>
                            <img src={findingBrilliantIcon} alt="login-logo" />
                        </div>
                        <div className={styles.right}>
                            <Stepper
                                currentStep={0}
                                steps={steps}
                            />
                            <Register key="Register" />
                        </div>
                    </div>}
                    {ventureLoading && (
                        <div className="pt-5">
                            <Loader />
                        </div>
                    )}
                </section>
            </div>
        </div>
    );
};

export default DemoDayRegister;
